<template>
  <v-menu offset-y top :close-on-content-click="false" v-model="open">
    <template v-slot:activator="{ on }">
      <v-btn color="primary" outlined x-small style="position: absolute" class="mt-5 ml-10" v-on="on">Batch edit</v-btn>
    </template>
    <v-card flat width="350">
      <v-card-title>Batch edit</v-card-title>
      <v-card-subtitle>Only checked fields will be updated</v-card-subtitle>
      <v-card-text class="pa-0">
        <v-container class="pt-0 px-6">
          <v-row>
            <v-col cols="2">
              <v-checkbox v-model="input.updateType" class="mt-2"/>
            </v-col>
            <v-col>
              <v-autocomplete v-model="input.typeId" outlined dense label="Container type"
                              :disabled="!input.updateType"
                              :items="types" item-text="name" item-value="id">
                <template v-slot:prepend-item>
                  <div class="pa-2 grey lighten-3 text-body-2 font-weight-medium cursor-pointer" @click="typeCreate=true">
                    <v-icon color="primary" class="mr-2">mdi-plus-thick</v-icon>Add new type
                  </div>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
        </v-container>
        <v-divider/>
      </v-card-text>
      <v-card-actions class="px-6">
        <v-spacer/>
        <v-btn plain color="primary" @click="open=false">Cancel</v-btn>
        <v-btn color="primary" @click="save" :loading="saving">Save</v-btn>
      </v-card-actions>
    </v-card>
    <inventory-bulk-containers-types-quick-create v-model="typeCreate" @create="typeCreated"/>
  </v-menu>
</template>

<script>
import InventoryBulkContainersTypesQuickCreate from '@/views/inventory/bulkContainers/InventoryBulkContainersTypesQuickCreate'

export default {
  name: 'InventoryBulkContainersBatchEdit',
  components: {InventoryBulkContainersTypesQuickCreate},
  props: {
    bulkContainers: {type:Array, required:true}
  },
  data() {
    return {
      open: false,
      input: {updateType: false,
              typeId:'',
              bulkContainers:[]},
      types: [{name:'none',id:null}],
      saving: false,
      typeCreate:false
    }
  },
  async created() {
    this.$lazyListLoad(this.types, 'bulkContainerTypes2', 'id,name', 100);
  },
  methods: {
    typeCreated(type) {
      this.types.push(type);
      this.input.typeId = type.id;
    },
    async save() {
      this.saving = true;
      this.input.bulkContainers = this.bulkContainers.map(tank => tank.id);
      const results = await this.$apiCall(`mutation InventoryBulkContainersBatchEdit($input: BulkContainersBatchUpdateInput!) {
                                              bulkContainersBatchUpdate(input:$input) {id,error}
                                            }`,
                                          {input:this.input});
      this.saving = false;
      if (!results.error) {
        this.open = false;
        const errorCount = results.data.bulkContainersBatchUpdate.length;
        this.$store.commit('setError', {type:errorCount ? 'warning' : 'success',
                                        message:`Updated ${this.bulkContainers.length - errorCount} of ${this.bulkContainers.length} bulk containers\
                                                  ${errorCount ? `(${errorCount} error${errorCount > 1 ? 's':''})` : ``}`});
        this.$emit('refresh', results.data.bulkContainersBatchUpdate);
      }
    }
  }
}
</script>